const SUSPENDED = "suspended";
const CANCELED = "canceled";
const ARCHIVED = "archived";

export const PREVENT_TRANSITION_STATUS = [SUSPENDED, CANCELED, ARCHIVED];

export const MERCHANT_ACCOUNT_STATUS = {
  INACTIVE: "inactive",
  ACTIVE: "active",
  SUSPENDED,
  REVIEW: "review",
  AUTH_REQUIRED: "auth_required",
  CANCELED,
  DEFERRED: "deferred",
  ARCHIVED
};
